const getMinPriceRange = (appliedRange, range) => {
  return appliedRange?.min || range?.min;
}

const getMaxPriceRange = (appliedRange, range) => {
  return appliedRange?.max || range?.max;
}

const formatPriceForDisplay = (appliedRange, range) => {
  const minPrice = getMinPriceRange(appliedRange, range);
  const maxPrice = getMaxPriceRange(appliedRange, range);
  return `$${minPrice}–$${maxPrice}`
}

export default formatPriceForDisplay;
